module.exports = __webpack_public_path__ + "static/media/banner2.df7e75db.jpg";